import React, { useCallback, useMemo } from "react";
import cx from "classnames";
import { useTranslate } from "hooks";
import s from "components/_ProductConfigurator/ProductConfiguratorComponent.module.scss";

import { ModalHolder } from "@ebay/nice-modal-react";
import { TechnicalDesignModal } from "components/_Modals/TechnicalDesignModal";
import { IconButton } from "components/IconButton/IconButton";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";

export const ProductConfiguratorResultSection = ({
  children,
  title,
  shouldHaveMaximizeBtn = true,
  viewWithTable = false,
  classNames,
}) => {
  const technicalDesignModal = useMemo(() => ({}), []);
  const { product } = useProductConfiguratorStore.use.productData() || {};

  const isProductAccessory = !!product?.accessoryInfo?.accessoryId;

  const translate = useTranslate();

  const handleOpenModal = useCallback(() => {
    technicalDesignModal.show();
  }, [technicalDesignModal]);

  return (
    <div className={classNames}>
      <div
        className={cx(
          "d-flex align-items-center justify-content-between",
          s.sectionHeader,
        )}
      >
        <h5 className="text-uppercase text20 mb-0">{title}</h5>
        {shouldHaveMaximizeBtn && (
          <>
            <IconButton
              icon="arrows-maximize-regular"
              className="border-0"
              iconClassName="icon-14"
              iconPrefix="trox"
              data-testid="technical-design-header-arrows-maximize-icon"
              onClick={handleOpenModal}
              tooltipText={translate("MAXIMIZE")}
              disabled={isProductAccessory}
            />
          </>
        )}
        <ModalHolder
          className="h-100"
          modal={TechnicalDesignModal}
          handler={technicalDesignModal}
          viewWithTable={viewWithTable}
        >
          {typeof children === "function"
            ? children({ isInModal: true })
            : children}
        </ModalHolder>
      </div>
      {typeof children === "function"
        ? children({ isInModal: false })
        : children}
    </div>
  );
};
